module.exports = __webpack_public_path__ + "static/media/text.db3c8d43.svg";